import {
  type DocsSearchKind,
  docsSearchKindFromHref,
} from "@/lib/docs-search-shared";

/** One row in `public/docs-search-index.json` after normalization. */
export interface DocsSearchIndexDocument {
  description: string;
  href: string;
  id: string;
  kind: DocsSearchKind;
  text: string;
  title: string;
  updatedAt: string;
}

/* eslint-disable complexity -- tolerant normalization of partial JSON rows */
function normalizeDocRow(
  d: Partial<DocsSearchIndexDocument>,
): DocsSearchIndexDocument {
  const href = String(d.href ?? "");
  const id = String(d.id ?? href);

  return {
    description: typeof d.description === "string" ? d.description : "",
    href,
    id,
    kind: d.kind ?? docsSearchKindFromHref(href),
    text: String(d.text ?? ""),
    title: String(d.title ?? ""),
    updatedAt:
      typeof d.updatedAt === "string" ? d.updatedAt : new Date(0).toISOString(),
  };
}
/* eslint-enable complexity */

export function normalizeDocsSearchIndexDocuments(
  raw: Partial<DocsSearchIndexDocument>[],
): DocsSearchIndexDocument[] {
  return raw.map((d) => normalizeDocRow(d));
}
